import Axios from "../Axios";

const API_URL = "/academic-years";

class AcademicYearService {
  async getAcademicYears(params = {}) {
    const final = { ...params };
    const response = await Axios.get(API_URL, {
      params: final,
    });
    return response.data.data;
  }


  async getAcademicYear(id) {
    const response = await Axios.get(`${API_URL}/${id}`);
    return response.data.data;
  }
}

export default new AcademicYearService();
